<template>
    <div>
      <client-accounting-special-invoice-report></client-accounting-special-invoice-report>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  